<template>
  <div class="student-enquiry-page">
    <section class="contact-us-section section-spacing" id="contact-us-section">
      <div class="container-fluid">
        <div class="row justify-content-center mt-5">
          <div class="col-lg-5 left-div">
            <div class="back">
              <div class="front">
                <div class="img-div">
                  <img
                    title="my-img"
                    src="@/assets/imgs/student-enquiry-form/3.png"
                    alt="idea"
                  />
                </div>
                <div class="text1">
                  Love to hear you!
                </div>
                <div class="text2">
                  When planning to study abroad, there are a thousand questions
                  that come to your mind. Will I get through the University of
                  my Dreams? How will I survive the years abroad alone without
                  family? What can I do top my college? How will I sustain the
                  finances? These and a million other questions are bound to
                  keep your mind occupied. Why you, your parents and family will
                  be equally pondering over a lot of things when it comes to
                  your abroad education plans. These worries and thoughts are
                  endless, but don’t let these bother you and your folks. Just
                  speak to us and we will have it sorted, however trivial it may
                  sound.
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 right-div mt-4">
            <form action="" method="POST" class="student-enq-form">
              <h2 class="enq-div">
                Student <span class="enq-txt">Enquiry Form</span>
              </h2>
              <div class="custom-form-control mt-4">
                <div class="form-spacing form-1">
                  <div class="form-name">
                    <label>Enter Name:</label>
                    <input
                      name="Name"
                      id="name_id"
                      type="text"
                      class="form-control"
                      placeholder="Enter Name"
                      required
                    />
                  </div>
                  <div class="form-email">
                    <label>Enter Email Address:</label>
                    <input
                      name="Email"
                      id="email_id"
                      type="text"
                      class="form-control"
                      placeholder="Enter Email"
                      required
                    />
                  </div>
                </div>
                <div class="form-spacing form-1">
                  <div class="form-name">
                    <label>Enter Mobile Number:</label>
                    <input
                      name="Phone"
                      id="phone_id"
                      type="tel"
                      class="form-control"
                      placeholder="Enter Phone Number"
                      required
                    />
                  </div>
                  <div class="form-name">
                    <label>Select State:</label>
                    <select
                      name="State"
                      id="state_id"
                      type="text"
                      class="form-control"
                      placeholder="Select State"
                      required
                    >
                      <option value="1">Maharashtra</option>
                      <option value="2">Goa</option>
                      <option value="3">Gujrat</option>
                    </select>
                  </div>
                </div>
                <div class="form-spacing form-1">
                  <div class="form-name">
                    <label>Select City:</label>
                    <select
                      name="City"
                      id="city_id"
                      type="text"
                      class="form-control"
                      placeholder="Select State"
                      required
                    >
                      <option value="1">Mumbai</option>
                      <option value="2">Pune</option>
                      <option value="3">Nashik</option>
                    </select>
                  </div>
                  <div class="form-name">
                    <label>Select Course:</label>
                    <select
                      name="Course"
                      id="course_id"
                      type="text"
                      class="form-control"
                      placeholder="Select Course"
                      required
                    >
                      <option value="1">Diploma</option>
                      <option value="2">Degree</option>
                    </select>
                  </div>
                </div>

                <div class="form-spacing">
                  <label>Select Specialization:</label>
                  <select
                    name="Specialization"
                    id="specialization_id"
                    type="text"
                    class="form-control"
                    placeholder="Enter your Message"
                  >
                    <option value="1">Science</option>
                    <option value="2">Commerce</option>
                  </select>
                </div>

                <div class="form-spacing">
                  <label>Select Country:</label>
                  <select
                    name="Country"
                    id="country_id"
                    type="text"
                    class="form-control"
                    placeholder="Select Country"
                  >
                    <option value="1"
                      ><img
                        src="https://cdn.britannica.com/68/7068-004-7848FEB4/Flag-Canada.jpg"
                      />
                      United States Of America
                    </option>
                    <option value="2">Canada</option>
                    <option value="3">France</option>
                    <option value="4">Russia</option>
                    <option value="5">Spain</option>
                  </select>
                </div>

                <div class="form-spacing form-1">
                  <div class="form-name">
                    <label>Enter Highest Qualification:</label>
                    <input
                      name="Qualification"
                      id="qualification_id"
                      type="text"
                      class="form-control"
                      placeholder="Masters"
                      required
                    />
                  </div>
                  <div class="form-email">
                    <label>Enter Budget:</label>
                    <input
                      name="Email"
                      id="email_id"
                      type="text"
                      class="form-control"
                      placeholder="20 Lakhs"
                      required
                    />
                  </div>
                </div>
                <div class="tick-policy">
                  <input
                    type="checkbox"
                    id="policy_id"
                    class="tick-round"
                  /><span class="policy-txt"
                    >I agree to the <a href="#">privacy policy.</a></span
                  >
                </div>
              </div>
              <div class="mt-3">
                <input type="submit" value="Submit" class="btn-secondary-red" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <section class="section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="text-center">
              <div class="enq-div mile-div" margin="auto">
                Our <span class="enq-txt">Milestone</span>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <b-row class="mile-row" xs="{1}" md="{2}" lg="{4}">
              <b-col v-for="(data, index) in milestoneData" :key="index">
                <div class="mile-card">
                  <div class="mile-icon">
                    <img
                      title="my-img"
                      :src="
                        require('@/assets/imgs/student-enquiry-form/' +
                          data.icon)
                      "
                      alt="people"
                    />
                  </div>
                  <div class="mile-txt1">{{ data.text1 }}</div>
                  <div class="mile-txt2">{{ data.text2 }}</div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="abroad-div enq-div" margin="auto">
          Why Student. <span class="enq-txt">Abroad Journey.</span>
        </div>
        <div class="abroad-txt1" margin="auto">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, sapien
          cursus sollicitudin eget fringilla.
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6 abroad-img-contact">
            <img
              src="@/assets/imgs/contact-us.svg"
              class="img-fluid border-all"
            />
          </div>
          <div class="col-md-6 col-xl-6">
            <div class="ab-right">
              <div class="ab-txt1">Know universities that fit you right!</div>
            </div>
            <p class="main-content-2">
              Your preferences, your profile and your grades. That’s all IT
              needs. Yes! We use an algorithm equipped with our experience and
              expertise to tailor-make a list of ideal universities for your
              abroad education.
            </p>
            <div class="pt-3 pt-lg-5">
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/live.svg"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Live</span>
              </div>
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/community.png"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Community</span>
              </div>
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/events.png"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Event</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row d-flex justify-content-between">
          <div class="col-md-6 col-xl-6">
            <div class="ab-right">
              <div class="ab-txt1">Connect with aspirants like you!</div>
            </div>
            <p class="main-content-2">
              We like to bring people of similar interests together. Yocket
              Connect is a community of help and guidance formed by the
              aspirants, alumni and counsellors. So, start networking and find
              someone with who shares your aspiration.
            </p>
            <div class="pt-3 pt-lg-5">
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/live.svg"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Live</span>
              </div>
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/community.png"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Community</span>
              </div>
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/events.png"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Event</span>
              </div>
            </div>
          </div>
          <div
            class="col-md-5 col-lg-5 d-flex justify-content-center abroad-admission-img"
          >
            <img
              src="@/assets/imgs/admission-1.png"
              class="img-fluid border-all"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section ">
      <div class="container">
        <div class="row d-flex justify-content-md-between">
          <div class="col-md-5 col-lg-5 abroad-ielts-img">
            <img
              src="@/assets/imgs/process-ielts.png"
              class="img-fluid border-all"
            />
          </div>
          <div class="col-md-6 col-xl-6">
            <div class="ab-right">
              <div class="ab-txt1">Keep track of your aspirations.</div>
            </div>
            <p class="main-content-2">
              A place where we give you some space! Space for you to apply for
              universities, track your applications, add task reminders, upload
              all your documents and even plan your finances for overseas
              education.
            </p>
            <div class="pt-3 pt-lg-5">
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/live.svg"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Live</span>
              </div>
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/community.png"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Community</span>
              </div>
              <div>
                <img
                  src="@/assets/imgs/student-enquiry-form/events.png"
                  class="img-fluid border-all abroad-icon-image"
                /><span class="abroad-points">Event</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row d-flex justify-content-md-between">
          <div class="col-md-5 col-lg-5 abroad-ielts-img">
            <img
              src="@/assets/imgs/edge-out-hero.png"
              class="img-fluid border-all"
            />
          </div>
          <div class="col-md-6 col-xl-6">
            <div class="ab-right enq-div">
              <div class="ab-txt1">
                Why Should. <span class="enq-txt">Prefer Aliff.</span>
              </div>
            </div>
            <p class="main-content-2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Euismod
              etiam ligula facilisis tortor. Tincidunt habitant venenatis
              adipiscing vestibulum sapien, neque. Vel habitant placerat leo
              nibh. Elit semper neque, nunc aenean. Diam tincidunt lorem
              malesuada odio nisi, pellentesque non feugiat.
            </p>
            <div class="pt-3 pt-lg-5">
              <div class="row abroad-prefer-row">
                <div class="col-md-5 col-lg-5">
                  <img
                    title="my-img"
                    src="@/assets/imgs/student-enquiry-form/check-icon.png"
                    alt="people"
                  />
                  <span>More Accurate</span>
                </div>
                <div class="col-md-5 col-lg-5">
                  <img
                    title="my-img"
                    src="@/assets/imgs/student-enquiry-form/check-icon.png"
                    alt="people"
                  />
                  <span>Easy Process</span>
                </div>
              </div>
              <div class="row pt-lg-2 abroad-prefer-row">
                <div class="col-md-5 col-lg-5">
                  <img
                    title="my-img"
                    src="@/assets/imgs/student-enquiry-form/check-icon.png"
                    alt="people"
                  />
                  <span>Track Process</span>
                </div>
                <div class="col-md-5 col-lg-5">
                  <img
                    title="my-img"
                    src="@/assets/imgs/student-enquiry-form/check-icon.png"
                    alt="people"
                  />
                  <span>24/7 Service</span>
                </div>
              </div>
              <div class="row pl-3 mt-5 abroad-know-btn">
                <button value="" class="btn-secondary-red">Know More</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Reviews Section -->

    <section class="intro-sm-section section-spacing">
      <div class="container-fluid review-container">
        <div class="enq-div" margin="auto">
          Recent <span class="enq-txt">Google</span> Reviews
        </div>
        <div class="abroad-txt1" margin="auto">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, sapien
          cursus sollicitudin eget fringilla.
        </div>

        <div
          class="google-review row d-flex justify-content-between align-items-center"
        >
          <div class="">
            <p class="d-flex align-items-center google-rating-align">
              <img src="@/assets/imgs/student-enquiry-form/google.png" />
              <strong class="px-2">Google Rating</strong>
            </p>
            <div class="d-flex align-items-center justify-content-between mx-1">
              <strong class="mt-1">4.9</strong>
              <span class="mx-2 d-flex">
                <img
                  title="my-img"
                  src="@/assets/imgs/student-enquiry-form/star.png"
                  alt="people"
                />
                <img
                  title="my-img"
                  src="@/assets/imgs/student-enquiry-form/star.png"
                  alt="people"
                />
                <img
                  title="my-img"
                  src="@/assets/imgs/student-enquiry-form/star.png"
                  alt="people"
                />
                <img
                  title="my-img"
                  src="@/assets/imgs/student-enquiry-form/star.png"
                  alt="people"
                />
                <img
                  title="my-img"
                  src="@/assets/imgs/student-enquiry-form/star.png"
                  alt="people"
                />
              </span>
              <span class="card-txt2 mt-2">- 58 Ratings</span>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button value="" class="btn-secondary-red">Write a review</button>
          </div>
        </div>

        <div class="row">
          <b-row class="review-row">
            <b-col
              class="col-lg-4 col-md-6 col-xs-1"
              v-for="(data, index) in reviewData"
              :key="index"
            >
              <div class="review-card">
                <div class="card-top mb-1">
                  <div class="card-t">
                    <div>
                      <img
                        title="my-img"
                        :src="
                          require('@/assets/imgs/student-enquiry-form/' +
                            data.image)
                        "
                        alt="people"
                      />
                    </div>
                    <div class="mt-auto mb-auto">
                      <span class="card-txt1">{{ data.name }}</span>
                      <div class="card-txt2">
                        <span class="review-email-text"
                          >{{ data.email }} - {{ data.time }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div>
                    <img
                      title="my-img"
                      :src="
                        require('@/assets/imgs/student-enquiry-form/' +
                          data.site)
                      "
                      alt="people"
                    />
                  </div>
                </div>
                <div class="star-icon">
                  <img
                    title="my-img"
                    :src="
                      require('@/assets/imgs/student-enquiry-form/' + data.star)
                    "
                    alt="people"
                  />
                  <img
                    title="my-img"
                    :src="
                      require('@/assets/imgs/student-enquiry-form/' + data.star)
                    "
                    alt="people"
                  />
                  <img
                    title="my-img"
                    :src="
                      require('@/assets/imgs/student-enquiry-form/' + data.star)
                    "
                    alt="people"
                  />
                  <img
                    title="my-img"
                    :src="
                      require('@/assets/imgs/student-enquiry-form/' + data.star)
                    "
                    alt="people"
                  />
                  <img
                    title="my-img"
                    :src="
                      require('@/assets/imgs/student-enquiry-form/' + data.star)
                    "
                    alt="people"
                  />
                </div>
                <div class="card-text">
                  {{ data.text }}
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>

    <!-- about us -->

    <section class="intro-sm-section section-spacing">
      <div class="container-fluid review-container">
        <div class="enq-div" margin="auto">
          What People <span class="enq-txt"> Says </span> About Us
        </div>
        <div class="abroad-txt1" margin="auto">
          Aliff is a global education consultant based in mumbai that
          specialises in helps students choose the Right Course, Right College,
          Right Country, anywhere in the world.
        </div>

        <b-row class="about-row">
          <b-col
            class="col-lg-3 col-md-6 col-sm-12 mt-2"
            v-for="(data, index) in aboutData"
            :key="index"
          >
            <div
              class="about-card"
              :style="{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.8)),url(${require('@/assets/imgs/student-enquiry-form/' +
                  data.image)})`
              }"
            >
              <div class="university-img-div">
                <img
                  title="my-img"
                  :src="
                    require('@/assets/imgs/student-enquiry-form/' +
                      data.university)
                  "
                  alt="university"
                />
              </div>
              <div>
                <button class="btn-about-card">{{ data.fields }}</button>
              </div>
              <div class="star-icon mt-2">
                <img
                  title="my-img"
                  :src="
                    require('@/assets/imgs/student-enquiry-form/' + data.star)
                  "
                  alt="people"
                />
                <img
                  title="my-img"
                  :src="
                    require('@/assets/imgs/student-enquiry-form/' + data.star)
                  "
                  alt="people"
                />
                <img
                  title="my-img"
                  :src="
                    require('@/assets/imgs/student-enquiry-form/' + data.star)
                  "
                  alt="people"
                />
                <img
                  title="my-img"
                  :src="
                    require('@/assets/imgs/student-enquiry-form/' + data.star)
                  "
                  alt="people"
                />
                <img
                  title="my-img"
                  :src="
                    require('@/assets/imgs/student-enquiry-form/' + data.star)
                  "
                  alt="people"
                />
              </div>
              <div class="about-card-text mt-2">
                {{ data.name }}
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>

    <!-- question ans section -->

    <section class="intro-sm-section section-spacing">
      <div class="container-fluid review-container">
        <div class="enq-div" margin="auto">
          Have A <span class="enq-txt"> Questions? </span>
        </div>
        <div class="abroad-txt1" margin="auto">
          Everything you need to know about the career and help.
        </div>

        <b-row class="faq-row">
          <b-col>
            <div class="accordion faq-accordion-contaner" role="tablist">
              <!-- <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-1
                    variant="info"
                    @click="showModalIcon('acc1')"
                    class="faq-accordion-btn"
                    >Is there a free trial available?
                    <span class="faq-icon"
                      ><img
                        :src="
                          require(`@/assets/imgs/student-enquiry-form/${
                            open_acc.includes('acc1') ? 'plus' : 'minus'
                          }.png`)
                        "
                    /></span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card> -->

              <b-card
                no-body
                class="mb-1 faq-acc-contain"
                v-for="(item, index) in faqData"
                :key="index"
              >
                <b-card-header
                  header-tag="header"
                  class="p-0 faq-acc"
                  role="tab"
                >
                  <button
                    block
                    v-b-toggle="'my-collapse' + index"
                    class="faq-accordion-btn"
                  >
                    {{ item.question }}
                    <span class="when-open faq-icon"
                      ><img
                        title="my-img"
                        src="@/assets/imgs/student-enquiry-form/minus.png"
                        alt="people"/></span
                    ><span class="when-closed faq-icon"
                      ><img
                        title="my-img"
                        src="@/assets/imgs/student-enquiry-form/plus.png"
                        alt="people"
                    /></span>
                  </button>
                </b-card-header>
                <b-collapse
                  :id="'my-collapse' + index"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body class="faq-card-body">
                    <b-card-text class="faq-card-txt">{{
                      item.ans
                    }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container-fluid review-container">
        <div class="enq-div" margin="auto">
          Start Your Study Abroad <span class="enq-txt"> Journey Now! </span>
        </div>
        <div class="abroad-txt1" margin="auto">
          <button value="" class="btn-secondary-red mt-5">Sign Up</button>
        </div>

        <b-row class="faq-row">
          <b-col>
            <div class="footer-abroad">
              <img
                title="my-img"
                src="@/assets/imgs/student-enquiry-form/abroad-image.png"
                alt="people"
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
  </div>
</template>

<script>
import { search_tags, bottom_search_tags } from "@/data/homeData";
import { mapGetters } from "vuex";
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";
import TechServices from "@/components/partials/TechServices.vue";
// import milestoneData from "@/data/milestoneData";

export default {
  name: "StudentEnquiryForm",
  metaInfo: {
    meta: [
      {
        name: "google-site-verification",
        content: "3AGVH8g4t8ldh8KcqAO8Ma3VnobGTNb-DxQdFoUQBTE"
      },
      { name: "msvalidate.01", content: "6E33F85EB785616D955B091C77828158" }
    ]
  },
  components: {
    BookFreeCounselling,
    RecentPostSection,
    TextTestimonialSlider,
    VideoTestimonialSlider,
    ContactusSection,
    TechServices
  },
  data() {
    return {
      open_acc: [],
      text:
        "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
      featured_universities: [],
      filter: {
        searchText: "",
        course_level: null,
        course_category: null,
        country: null
      },

      serviceId: 1,
      styleServicesRow: ["60%", "20%", "20%"],
      search_tags,
      bottom_search_tags,
      milestoneData: [
        {
          icon: "people_alt.png",
          text1: "5L+",
          text2: "Total Number Of Users"
        },
        {
          icon: "vector.png",
          text1: "100%",
          text2: "Success rate"
        },
        {
          icon: "edu.png",
          text1: "1400+",
          text2: "No. of Universities"
        },
        {
          icon: "msg.png",
          text1: "20K+",
          text2: "No. of active discussion"
        }
      ],
      reviewData: [
        {
          image: "joe.png",
          name: "Joe Lawson",
          email: "@joelawson",
          time: "10 min ago",
          site: "google.png",
          star: "star.png",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollis mauris blandit sollicitudin amet. Tellus dignissim amet, dictum quis pulvinar. Hendrerit imperdiet et cursus tempor, sed amet. Facilisis phasellus eu nulla felis in mattis."
        },
        {
          image: "joe.png",
          name: "Joe Lawson",
          email: "@joelawson",
          time: "10 min ago",
          site: "google.png",
          star: "star.png",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollis mauris blandit sollicitudin amet. Tellus dignissim amet, dictum quis pulvinar. Hendrerit imperdiet et cursus tempor, sed amet. Facilisis phasellus eu nulla felis in mattis."
        },
        {
          image: "joe.png",
          name: "Joe Lawson",
          email: "@joelawson",
          time: "10 min ago",
          site: "google.png",
          star: "star.png",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollis mauris blandit sollicitudin amet. Tellus dignissim amet, dictum quis pulvinar. Hendrerit imperdiet et cursus tempor, sed amet. Facilisis phasellus eu nulla felis in mattis."
        },
        {
          image: "joe.png",
          name: "Joe Lawson",
          email: "@joelawson",
          time: "10 min ago",
          site: "google.png",
          star: "star.png",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollis mauris blandit sollicitudin amet. Tellus dignissim amet, dictum quis pulvinar. Hendrerit imperdiet et cursus tempor, sed amet. Facilisis phasellus eu nulla felis in mattis."
        },
        {
          image: "joe.png",
          name: "Joe Lawson",
          email: "@joelawson",
          time: "10 min ago",
          site: "google.png",
          star: "star.png",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollis mauris blandit sollicitudin amet. Tellus dignissim amet, dictum quis pulvinar. Hendrerit imperdiet et cursus tempor, sed amet. Facilisis phasellus eu nulla felis in mattis."
        },
        {
          image: "joe.png",
          name: "Joe Lawson",
          email: "@joelawson",
          time: "10 min ago",
          site: "google.png",
          star: "star.png",
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollis mauris blandit sollicitudin amet. Tellus dignissim amet, dictum quis pulvinar. Hendrerit imperdiet et cursus tempor, sed amet. Facilisis phasellus eu nulla felis in mattis."
        }
      ],
      aboutData: [
        {
          image: "about1.png",
          university: "stanford.png",
          fields: "Engineering",
          star: "star.png",
          name: "Maye Musk"
        },
        {
          image: "about2.png",
          university: "stanford.png",
          fields: "Business Management",
          star: "star.png",
          name: "Niraj Naik"
        },
        {
          image: "about1.png",
          university: "stanford.png",
          fields: "Medicine",
          star: "star.png",
          name: "Madhvi Shah"
        },
        {
          image: "about2.png",
          university: "stanford.png",
          fields: "Engineering",
          star: "star.png",
          name: "Jeffrey"
        }
      ],
      faqData: [
        {
          question: "Is there a free trial available?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        },
        {
          question: "Can I change my plan later?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        },
        {
          question: "Is there a free trial available?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        },
        {
          question: "What is your cancellation policy?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        },
        {
          question: "Can other info be added to an invoice?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        },
        {
          question: "How does billing work?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        },
        {
          question: "How do I change my account email?",
          ans:
            "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
        }
      ],
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      destinationSlider: {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "ease",
        useTransform: true,
        speed: 1000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      },
      counsellorSlider: {
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      },
      teamIntroSlider: {
        slidesToShow: 4.5,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 0,
        // speed: 5000,
        // cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  mounted() {
    // this.openModal();
    // this.reInit();
    // this.$refs["event-modal"].show();

    // $('#event-modal').modal('show')

    if (window.innerWidth >= 1024) {
      this.styleServicesRow = ["60%", "20%", "20%"];
    } else {
      this.styleServicesRow = ["100%", "100%", "100%"];
    }
  },
  computed: {
    ...mapGetters(["getCountries"])
  },
  beforeUpdate() {
    // if (this.$refs.destinationSlider) {
    //   this.$refs.destinationSlider.destroy();
    // }
  },
  updated() {
    // this.$nextTick(function () {
    //   if (this.$refs.destinationSlider) {
    //     this.$refs.destinationSlider.create(this.slickOptions);
    //   }
    // });
  },
  methods: {
    showModalIcon(acc_name) {
      if (this.open_acc.includes(acc_name)) {
        this.open_acc.splice(this.open_acc.indexOf(acc_name), 1);
      } else {
        this.open_acc.push(acc_name);
      }
    },
    onKeySearch(e) {
      if (e.keyCode === 13) {
        this.goToSearchPage();
      }
    },
    onClickSearchTag(tag_obj) {
      switch (tag_obj.type) {
        case "country":
          this.filter.country = tag_obj;
          break;

        case "course_level":
          this.filter.course_level = tag_obj;
          break;

        case "course_category":
          this.filter.course_category = tag_obj;
          break;

        case "search":
          this.filter.searchText = tag_obj.name;
          break;
      }
      this.goToSearchPage();
    },
    goToSearchPage() {
      window.courseFilter = this.filter;
      this.$router.push("/search/search");
    },
    showContent(id) {
      console.log(window.innerWidth);
      if (window.innerWidth >= 1024) {
        const newStyleServiceRow = this.styleServicesRow.map((val, i) =>
          i === id - 1 ? "60%" : "20%"
        );
        this.styleServicesRow = newStyleServiceRow;
      } else {
        this.styleServicesRow = ["100%", "100%", "100%"];
      }
      this.serviceId = id;
    },
    async getData() {
      try {
        const featured_universities = await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    }
  },
  beforeMount() {
    this.getData();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/StudentEnquiryForm.vue